import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';

import './App.css';
import ExerciseDetail from './pages/ExerciseDetail';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Register from './components/Register';
import Login from './components/Login';
import Account from './pages/Account';
import { ForgotPassword } from './components/ForgotPassword';
import TrainerRegistration from './components/TrainerRegisteration';
import TrainerLogin from './components/TrainerLogin';
import TrainerAccount from './pages/TrainerAccount';
import Trainers from './pages/Trainers';

const App = () => {
  return (
    <Box width="400px" sx={{ width: { xl: '1488px' }}} m="auto">
      <Navbar />
      <Routes>
      <Route path="/account" element={<Account />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/exercise/:id" element={<ExerciseDetail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/trainer-login" element={<TrainerLogin />} />
        <Route path="/trainer-register" element={<TrainerRegistration />} />
        <Route path="/trainer-account" element={<TrainerAccount />} />
        <Route path="/trainers" element={<Trainers />} />
        
      </Routes>
      <Footer />
    </Box>
  );
};

export default App;
